import { addNotification, updateNotification } from "./alerts";
import { createCreativeJobAndWaitForResponse } from "./jobs";
import { promoteCreativeJobNotification } from "./creativeJobs";
import { formatDateForStatistics } from "../utils/date";
import { getUniqueID } from "../utils/numbers";
import { getCustomReportSourcePath } from "../utils/customReportSource";
import { ALERTS_ASYNC_STATUS } from "../utils/constants";
import { CREATIVE_JOB_STATUS } from "../utils/creativeJobStatus";
import { CREATIVE_JOB_TYPES, LaunchError } from "../utils/errors";
import {
  getCreativeJobAlertMessageKey,
  mapJobResultToGenerationData,
} from "../utils/creativeJobsNotifications";

const CUSTOM_REPORT_JOB_TIMEOUT_MS = 15 * 60 * 1000;
const TEMPLATE_CUSTOM = "custom";

export const startGenerateCustomReport =
  ({
    template,
    customPrompt,
    format,
    language,
    startDateTime,
    endDateTime,
    campaignID,
    onJobCreated = () => {},
  }) =>
  async (dispatch) => {
    const alertID = getUniqueID();
    let notificationId = alertID;
    const sourcePath = getCustomReportSourcePath({ campaignID });
    const payloadSnapshot = {
      modalType: "customReport",
      template,
      format,
      language,
      startDateTime,
      endDateTime,
      sourcePath,
      ...(campaignID ? { campaignID } : {}),
      ...(template === TEMPLATE_CUSTOM && customPrompt ? { customPrompt } : {}),
    };

    try {
      dispatch(
        addNotification({
          type: "generatingCustomReport",
          id: alertID,
          status: ALERTS_ASYNC_STATUS.LOADING,
          progress: 0,
          jobType: CREATIVE_JOB_TYPES.generateCustomReport,
          messageKey: getCreativeJobAlertMessageKey({
            jobType: CREATIVE_JOB_TYPES.generateCustomReport,
          }),
          generationData: {
            ...payloadSnapshot,
            isGenerating: true,
          },
        })
      );

      const data = await createCreativeJobAndWaitForResponse({
        dispatch,
        jobType: CREATIVE_JOB_TYPES.generateCustomReport,
        timeoutMs: CUSTOM_REPORT_JOB_TIMEOUT_MS,
        language,
        payload: {
          template,
          format,
          language,
          startDateTime: formatDateForStatistics(startDateTime),
          endDateTime: formatDateForStatistics(endDateTime),
          sourcePath,
          ...(campaignID ? { campaignID } : {}),
          ...(template === TEMPLATE_CUSTOM && customPrompt
            ? { customPrompt }
            : {}),
        },
        onJobCreated: ({ jobID }) => {
          dispatch(
            promoteCreativeJobNotification({ fromId: notificationId, jobID })
          );
          notificationId = jobID;
          onJobCreated({ jobID });
        },
      });

      dispatch(
        updateNotification(notificationId, {
          status: ALERTS_ASYNC_STATUS.SUCCESS,
          progress: 100,
          generationData: mapJobResultToGenerationData({
            job: {
              jobType: CREATIVE_JOB_TYPES.generateCustomReport,
              status: CREATIVE_JOB_STATUS.SUCCESS,
              response: data,
            },
            payloadSnapshot,
          }),
        })
      );

      return data;
    } catch (error) {
      const errorFormatted = dispatch(
        LaunchError(error, false, [], {
          creativeJobType: CREATIVE_JOB_TYPES.generateCustomReport,
          functionName: "startGenerateCustomReport",
        })
      );

      dispatch(
        updateNotification(notificationId, {
          status: ALERTS_ASYNC_STATUS.ERROR,
          message: errorFormatted.message,
          progress: 100,
          generationData: {
            ...payloadSnapshot,
            isGenerating: false,
          },
        })
      );

      return errorFormatted;
    }
  };
